export default {
  BILL: 'Bill',
  DECLARE: 'Declaration',
  IDCARD: 'IDCARD',
  KBIS: 'KBIS',
  PROOF: 'ProofAdress',
  RECEIPE: 'Receipe',
  RIB: 'RIB',
  STATUS: 'Status',
  IDCARDHOST: 'IdCardHost'
}
